<template>
  <div :id="`${page}_skeleton_loader`" :class="[containerHeight, 'w-full']">
    <div
      v-if="page === loaderPages.ENTITY_PROPERTIES"
      class="flex flex-col gap-6 max-w-3xl mx-auto px-4 md:px-8 py-8"
    >
      <div class="flex items-center gap-2">
        <div class="h-[20px] w-[100px] bg_dark_6 hsk pulse" />
      </div>

      <div class="flex items-center gap-4">
        <div class="w-11 h-11 bg_dark_6 hsk pulse" />
        <div class="flex flex-col gap-1.5">
          <div class="h-[18px] w-[200px] bg_dark_6 hsk pulse" />
          <div class="h-[14px] w-[100px] bg_dark_6 hsk pulse" />
        </div>
      </div>

      <div class="w-full">
        <div class="flex gap-4 mb-4">
          <div class="h-[30px] w-1/3 bg_dark_6 hsk pulse" />
          <div class="h-[30px] w-1/3 bg_dark_6 hsk pulse" />
          <div class="h-[30px] w-1/3 bg_dark_6 hsk pulse" />
        </div>

        <div class="flex flex-col gap-2">
          <div v-for="index in 8" :key="index" class="flex gap-4">
            <div class="h-[40px] w-1/3 bg_dark_6 hsk pulse" />
            <div class="h-[40px] w-1/3 bg_dark_6 hsk pulse" />
            <div class="h-[40px] w-1/3 bg_dark_6 hsk pulse" />
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="page === loaderPages.DETAIL"
      class="grid grid-cols-12 gap-4 w-full"
    >
      <div class="col-span-3 flex flex-col gap-2">
        <div class="h-[30px] bg_dark_6 hsk pulse" />
        <div class="h-[20vh] bg_dark_6 hsk pulse" />
        <div class="h-[44vh] bg_dark_6 hsk pulse" />
        <div class="h-[16vh] bg_dark_6 hsk pulse" />
      </div>

      <div class="col-span-6 flex flex-col gap-4">
        <div class="h-[30px] bg_dark_6 hsk pulse" />
        <div class="h-[50vh] bg_dark_6 hsk pulse" />
      </div>

      <div class="col-span-3 flex flex-col gap-2">
        <div class="h-[30vh] bg_dark_6 hsk pulse" />
        <div class="h-[30vh] bg_dark_6 hsk pulse" />
      </div>
    </div>

    <div v-if="page === loaderPages.BILLING_PROMPT" class="w-full">
      <div class="flex flex-col w-full">
        <div class="w-full h-[40px] bg_dark_6 hsk pulse" />
      </div>
    </div>

    <div
      v-if="page === loaderPages.EMAIL"
      :class="[
        'grid',
        'grid-cols-12',
        'gap-4',
        'w-full',
        index === 0 ? 'h-[350px]' : 'h-[270px]',
      ]"
    >
      <div class="col-span-12 flex flex-col gap-2 bg_dark_4 w-full">
        <div class="h-[15px] w-full bg_dark_6 hsk pulse" />
        <div class="h-[15px] w-1/2 bg_dark_6 hsk pulse" />
        <div class="h-[15px] mt-3 w-full bg_dark_6 hsk pulse" />
        <div class="h-[15px] w-full bg_dark_6 hsk pulse" />
        <div class="h-[15px] w-1/2 bg_dark_6 hsk pulse" />
        <div class="h-[15px] mt-3 w-full bg_dark_6 hsk pulse" />
        <div class="h-[15px] w-1/2 bg_dark_6 hsk pulse" />
        <div
          v-if="index === 0"
          class="h-[15px] mt-3 w-full bg_dark_6 hsk pulse"
        />
        <div v-if="index === 0" class="h-[15px] w-full bg_dark_6 hsk pulse" />
        <div v-if="index === 0" class="h-[15px] w-1/2 bg_dark_6 hsk pulse" />
      </div>
    </div>

    <div
      v-if="page === loaderPages.CONVERSATION_LEFT_PANEL"
      class="flex flex-col h-full border_right"
    >
      <div class="flex flex-col gap-3 border_bottom p-3">
        <div class="h-[40px] w-full bg_dark_6 hsk pulse" />
        <div class="h-[30px] w-full bg_dark_6 hsk pulse" />
      </div>

      <div class="flex flex-col gap-1 p-2">
        <div class="h-[68px] w-full bg_dark_6 hsk pulse" />
        <div class="h-[68px] w-full bg_dark_6 hsk pulse" />
        <div class="h-[68px] w-full bg_dark_6 hsk pulse" />
        <div class="h-[68px] w-full bg_dark_6 hsk pulse" />
        <div class="h-[68px] w-full bg_dark_6 hsk pulse" />
        <div class="h-[68px] w-full bg_dark_6 hsk pulse" />
        <div class="h-[68px] w-full bg_dark_6 hsk pulse" />
        <div class="h-[68px] w-full bg_dark_6 hsk pulse" />
        <div class="h-[68px] w-full bg_dark_6 hsk pulse" />
        <div class="h-[68px] w-full bg_dark_6 hsk pulse" />
      </div>
    </div>

    <div
      v-if="page === loaderPages.CONVERSATION_RIGHT_PANEL"
      class="flex flex-col h-full my-4 mx-3 gap-2"
    >
      <div class="h-[200px] w-full bg_dark_6 hsk pulse" />
      <div class="h-[460px] w-full bg_dark_6 hsk pulse" />
      <div class="h-[40px] w-full bg_dark_6 hsk pulse" />
    </div>

    <div
      v-if="page === loaderPages.CONVERSATION_RIGHT_PANEL_LIST"
      class="h-[180px] w-full bg_dark_6 hsk pulse my-4 mx-3"
    />

    <div
      v-if="page === loaderPages.OUTREACH_RESEARCH"
      class="grid grid-cols-12 gap-4 w-full h-[500px]"
    >
      <div class="col-span-12 flex flex-col gap-2 bg_dark_4 w-full">
        <div class="h-[15px] w-full bg_dark_6 hsk pulse" />
        <div class="h-[15px] w-full bg_dark_6 hsk pulse" />
        <div class="h-[15px] w-1/2 bg_dark_6 hsk pulse" />
        <div class="h-[15px] mt-3 w-full bg_dark_6 hsk pulse" />
        <div class="h-[15px] w-full bg_dark_6 hsk pulse" />
        <div class="h-[15px] w-full bg_dark_6 hsk pulse" />
        <div class="h-[15px] w-full bg_dark_6 hsk pulse" />
        <div class="h-[15px] w-full bg_dark_6 hsk pulse" />
        <div class="h-[15px] w-full bg_dark_6 hsk pulse" />
        <div class="h-[15px] w-1/2 bg_dark_6 hsk pulse" />
        <div class="h-[15px] mt-3 w-full bg_dark_6 hsk pulse" />
        <div class="h-[15px] w-full bg_dark_6 hsk pulse" />
        <div class="h-[15px] w-full bg_dark_6 hsk pulse" />
        <div class="h-[15px] w-full bg_dark_6 hsk pulse" />
        <div class="h-[15px] w-1/2 bg_dark_6 hsk pulse" />
      </div>
    </div>

    <div
      v-if="page === loaderPages.ONBOARDING"
      class="h-screen flex flex-col"
      style="height: calc(100vh - (78px + var(--banner-height)))"
    >
      <div class="w-full h-full grid grid-cols-2 gap-4">
        <div class="flex flex-col overflow-y-auto px-[13.2vw] py-[16vh]">
          <div class="h-[38px] w-4/5 bg_dark_6 hsk pulse" />
          <div class="h-[20px] w-full bg_dark_6 hsk pulse mt-3" />
          <div class="h-[20px] w-1/3 bg_dark_6 hsk pulse mt-1" />
          <div class="h-[32px] w-full bg_dark_6 hsk pulse mt-8" />
        </div>

        <div class="flex items-center justify-center rounded-lg p-6">
          <div class="size-full bg_dark_6 hsk pulse" />
        </div>
      </div>
    </div>

    <div
      v-if="page === loaderPages.HOME_OVERVIEW"
      class="grid grid-cols-2 gap-2"
    >
      <div
        v-for="index in 2"
        :key="index"
        class="col-span-1 flex flex-col gap-2"
      >
        <div
          class="flex flex-col min-h-[400px] container_bg_color rounded-lg p-3 gap-4"
        >
          <div v-for="index in 2" :key="index" class="flex flex-col gap-4">
            <div class="flex flex-row gap-4 items-center">
              <div class="size-10 bg_dark_6 rsk pulse" />
              <div class="h-[20px] w-[180px] bg_dark_6 hsk pulse" />
            </div>

            <div class="flex flex-row gap-4 items-center">
              <div class="size-10 bg_dark_6 rsk pulse" />
              <div class="h-[20px] w-[280px] bg_dark_6 hsk pulse" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="page === loaderPages.HOME_ANALYTICS"
      class="grid grid-cols-3 gap-2"
    >
      <div
        v-for="index in 6"
        :key="index"
        class="col-span-1 container_bg_color min-h-[206px] p-3"
      >
        <div class="h-[20px] w-[200px] bg_dark_6 hsk pulse" />
      </div>
    </div>

    <div v-if="page === loaderPages.HOME_ACTIVITY"></div>

    <div v-if="page === loaderPages.GET_STARTED">
      <div class="flex flex-col gap-9">
        <div class="flex flex-col gap-1">
          <div class="h-[40px] w-[280px] bg_dark_6 hsk pulse mt-1" />
          <div class="h-[24px] w-[180px] bg_dark_6 hsk pulse mt-1" />
        </div>

        <div
          class="flex flex-col gap-5 w-full px-10 py-8 rounded-2xl container_bg_color"
        >
          <div class="h-[28px] w-1/6 bg_dark_6 hsk pulse mt-1" />

          <div class="grid grid-cols-3 gap-4">
            <div
              v-for="index in 3"
              :key="index"
              class="col-span-1 flex flex-col gap-1"
            >
              <div
                class="h-[26vh] w-full !rounded-xl bg_dark_6 hsk pulse mt-1"
              />
              <div class="h-[24px] w-3/5 bg_dark_6 hsk pulse mt-1" />
              <div class="h-[18px] w-1/5 bg_dark_6 hsk pulse mt-1" />
            </div>
          </div>

          <div class="h-[26px] w-1/4 bg_dark_6 hsk pulse mt-1" />
        </div>

        <div v-for="index in 2" :key="index" class="flex flex-col gap-3">
          <div class="h-[28px] w-[180px] bg_dark_6 hsk pulse mt-1" />
          <div class="flex flex-row gap-4">
            <div
              v-for="dindex in 4 / index"
              :key="dindex"
              class="w-[310px] h-[314px] rounded-lg container_bg_color flex flex-col gap-1 justify-end p-4"
            >
              <div class="h-[20px] w-[40px] bg_dark_6 hsk pulse mt-1" />
              <div class="h-[20px] w-[190px] bg_dark_6 hsk pulse mt-1" />
              <div class="flex flex-col">
                <div class="h-[20px] w-[280px] bg_dark_6 hsk pulse mt-1" />
                <div class="h-[20px] w-[180px] bg_dark_6 hsk pulse mt-1" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="page === loaderPages.PROFILE_ICON"
      :class="`size-[${rskSize}px] bg_dark_6 rsk pulse`"
    />

    <div
      v-if="page === loaderPages.GENERATE_NUMBER"
      class="flex flex-col gap-1 bg_white_4 p-4 rounded-lg"
    >
      <div class="h-[30px] w-[230px] bg_dark_6 hsk pulse" />
      <div class="h-[14px] w-[130px] bg_dark_6 hsk pulse" />
    </div>

    <div v-if="page === loaderPages.CALL_DETAILS" class="flex flex-col gap-6">
      <div class="flex flex-col gap-2">
        <div class="h-[14px] w-[100px] bg_dark_6 hsk pulse" />
        <div class="h-[26px] w-[180px] bg_dark_6 hsk pulse" />
      </div>

      <InfoGrid v-for="index in 3" :key="index">
        <div class="flex flex-col gap-2">
          <div class="h-[14px] w-[100px] bg_dark_6 hsk pulse" />
          <div class="h-[26px] w-[180px] bg_dark_6 hsk pulse" />
        </div>

        <div class="flex flex-col gap-2">
          <div class="h-[14px] w-[100px] bg_dark_6 hsk pulse" />
          <div class="h-[26px] w-[180px] bg_dark_6 hsk pulse" />
        </div>
      </InfoGrid>

      <div class="flex flex-col gap-2">
        <div class="h-[14px] w-[80px] bg_dark_6 hsk pulse" />
        <div class="h-[300px] w-full bg_dark_6 hsk pulse" />
      </div>
    </div>

    <div
      v-if="page === loaderPages.CALL_CAMPAIGN_ENTITIES"
      class="flex flex-col gap-1"
    >
      <div v-for="index in 4" :key="index" class="flex flex-row gap-2 p-[6px]">
        <div class="size-[42px] bg_dark_6 rsk pulse" />

        <div class="flex flex-col gap-1">
          <div class="h-[18px] w-[180px] bg_dark_6 hsk pulse" />
          <div class="h-[18px] w-[120px] bg_dark_6 hsk pulse" />
        </div>
      </div>
    </div>

    <div
      v-if="page === loaderPages.CONTAINER_INFO_ITEM"
      class="flex flex-col size-full font-medium text_color"
    >
      <span class="text-sm">{{ text }}</span>
      <div class="h-[14px] w-[80px] bg_dark_6 hsk pulse mt-2" />

      <div class="size-full flex items-center justify-center">
        <div class="size-[40%] bg_dark_6 hsk pulse" />
      </div>
    </div>

    <div v-if="page === loaderPages.ANALYTICS" class="flex flex-col gap-2">
      <div class="flex flex-col gap-4">
        <div class="flex flex-row gap-1">
          <div
            v-for="index in 6"
            :key="index"
            class="h-[20px] w-[90px] bg_dark_6 hsk pulse mx-3 my-2"
          />
        </div>

        <div class="flex flex-row gap-1">
          <div
            v-for="index in 3"
            :key="index"
            class="h-[18px] w-[60px] bg_dark_6 hsk pulse mx-3 my-2"
          />
        </div>
      </div>

      <div class="grid grid-cols-3 gap-2">
        <div
          v-for="index in 3"
          :key="index"
          class="col-span-1 h-[210px] w-full gap-2 rounded-lg container_bg_color p-3"
        >
          <div class="h-[18px] w-[180px] bg_dark_6 hsk pulse" />
        </div>
      </div>

      <div class="grid grid-cols-2 gap-2">
        <div
          v-for="index in 2"
          :key="index"
          class="col-span-1 h-[320px] w-full gap-2 rounded-lg container_bg_color p-3"
        >
          <div class="h-[18px] w-[180px] bg_dark_6 hsk pulse" />
        </div>
      </div>

      <div class="grid grid-cols-1 gap-2">
        <div
          v-for="index in 1"
          :key="index"
          class="col-span-1 h-[320px] w-full gap-2 rounded-lg container_bg_color p-3"
        >
          <div class="h-[18px] w-[180px] bg_dark_6 hsk pulse" />
        </div>
      </div>
    </div>

    <div
      v-if="page === loaderPages.EMAIL_PREVIEW"
      class="flex flex-col gap-2 w-full p-4"
    >
      <div class="h-[15px] w-full bg_dark_6 hsk pulse" />
      <div class="h-[15px] w-1/2 bg_dark_6 hsk pulse" />
      <div class="h-[15px] mt-3 w-full bg_dark_6 hsk pulse" />
      <div class="h-[15px] w-full bg_dark_6 hsk pulse" />
      <div class="h-[15px] w-1/2 bg_dark_6 hsk pulse" />
      <div class="h-[15px] mt-3 w-full bg_dark_6 hsk pulse" />
      <div class="h-[15px] w-1/2 bg_dark_6 hsk pulse" />
      <div class="h-[15px] mt-3 w-full bg_dark_6 hsk pulse" />
      <div class="h-[15px] w-full bg_dark_6 hsk pulse" />
      <div class="h-[15px] w-1/2 bg_dark_6 hsk pulse" />
      <!-- Add more lines to fill the space as needed -->
      <div class="h-[15px] mt-3 w-full bg_dark_6 hsk pulse" />
      <div class="h-[15px] w-full bg_dark_6 hsk pulse" />
      <div class="h-[15px] w-1/2 bg_dark_6 hsk pulse" />
      <div class="h-[15px] mt-3 w-full bg_dark_6 hsk pulse" />
      <div class="h-[15px] w-full bg_dark_6 hsk pulse" />
      <div class="h-[15px] w-1/2 bg_dark_6 hsk pulse" />
    </div>

    <div
      v-if="page === loaderPages.ANALYTICS_CHART_TABLE"
      class="h-[310px] w-full bg_dark_6 hsk pulse"
    />

    <div
      v-if="page === loaderPages.TABLE"
      class="flex items-center justify-center"
    >
      <ThemeImage
        class="size-[96px] my-[44px] pulse"
        :icon="imageNames.TABLE_LOADER"
        alt="table_loader"
      />
    </div>

    <div
      v-if="page === loaderPages.CHART"
      class="flex items-center justify-center"
    >
      <ThemeImage
        class="size-[96px] my-[44px] pulse"
        :icon="imageNames.CHART_LOADER"
        alt="chart_loader"
      />
    </div>

    <div
      v-if="page === loaderPages.WORKSPACE_SECTION"
      class="flex flex-row w-full max-h-[85vh] items-center justify-center proxima_nova text_color"
    >
      <div class="flex flex-col gap-9 w-full h-[90vh] overflow-hidden">
        <div class="flex flex-row p-10 gap-10 justify-evenly">
          <!-- Left side - Form skeleton -->
          <div class="flex flex-col gap-2 w-1/3 mt-32">
            <div class="flex flex-col gap-2 items-start">
              <!-- Back button skeleton -->
              <div class="flex flex-row gap-1 items-center mb-6">
                <div class="size-4 bg_dark_6 rounded-full hsk pulse" />
                <div class="h-[13px] w-[40px] bg_dark_6 hsk pulse" />
              </div>

              <!-- Title and subtitle skeleton -->
              <div class="flex flex-col mb-10">
                <div class="h-[36px] w-[280px] bg_dark_6 hsk pulse mb-2" />
                <div class="h-[20px] w-[320px] bg_dark_6 hsk pulse" />
              </div>
            </div>

            <!-- Form fields skeleton -->
            <div class="flex flex-col gap-4">
              <!-- Workspace Name field -->
              <div class="flex flex-col gap-2">
                <div class="h-[16px] w-[120px] bg_dark_6 hsk pulse" />
                <div class="h-[40px] w-full bg_dark_6 hsk pulse rounded-md" />
              </div>

              <!-- Company Website field -->
              <div class="flex flex-col gap-2">
                <div class="h-[16px] w-[140px] bg_dark_6 hsk pulse" />
                <div class="h-[40px] w-full bg_dark_6 hsk pulse rounded-md" />
              </div>
            </div>

            <!-- Button skeleton -->
            <div
              class="h-[40px] w-[160px] bg_dark_6 hsk pulse rounded-md mt-10"
            />
          </div>

          <!-- Right side - Image skeleton -->
          <div class="flex flex-col gap-2 w-1/2">
            <div
              class="max-w-[750px] max-h-[650px] w-full h-[650px] bg_dark_6 hsk pulse rounded-lg mx-6"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="page === loaderPages.AUDIO_PLAYER"
      class="h-[34px] w-full bg_dark_6 hsk pulse"
    />

    <div v-if="page === loaderPages.NAV_LIST" class="flex flex-col gap-2">
      <div
        v-for="index in 10"
        :key="index"
        class="flex flex-row gap-3 items-center py-3 px-4"
      >
        <div
          :class="`size-[${rskSize}px] min-w-[${rskSize}px] min-h-[${rskSize}px] bg_dark_6 rsk pulse`"
        />

        <div class="flex flex-col gap-2 w-full">
          <div class="h-[18px] w-4/5 bg_dark_6 hsk pulse" />
          <div class="h-[18px] w-2/5 bg_dark_6 hsk pulse" />
        </div>
      </div>
    </div>

    <div
      v-if="page === loaderPages.CALL_LOG_DETAILS"
      class="flex flex-col gap-4"
    >
      <InfoGrid :gap="8" :columns="3">
        <div v-for="index in 7" :key="index" class="flex flex-col gap-2">
          <div class="h-[18px] w-4/5 bg_dark_6 hsk pulse" />
          <div class="h-[18px] w-2/5 bg_dark_6 hsk pulse" />
        </div>
      </InfoGrid>

      <div class="border_bottom" />

      <div class="flex flex-col gap-2">
        <div class="h-[18px] w-[100px] bg_dark_6 hsk pulse" />
        <div class="h-[18px] w-full bg_dark_6 hsk pulse" />
        <div class="h-[18px] w-full bg_dark_6 hsk pulse" />
      </div>
    </div>

    <div
      v-if="page === loaderPages.CALL_LOG_RECORDING_AND_TRANSCRIPT"
      class="flex flex-col gap-2"
    >
      <CustomContainer padding="p-4">
        <div class="h-[34px] w-full bg_dark_6 hsk pulse" />
      </CustomContainer>

      <CustomContainer padding="p-4">
        <div class="flex flex-col gap-4">
          <div
            v-for="index in 8"
            :key="index"
            class="flex flex-row gap-3 items-center"
          >
            <div :class="`size-[${rskSize}px] bg_dark_6 rsk pulse`" />

            <div class="flex flex-col gap-2">
              <div class="h-[18px] w-[220px] bg_dark_6 hsk pulse" />
              <div class="h-[18px] w-[90px] bg_dark_6 hsk pulse" />
            </div>
          </div>
        </div>
      </CustomContainer>
    </div>

    <div v-if="page === loaderPages.ENTITY_DETAILS" class="flex flex-col gap-2">
      <CustomContainer>
        <div class="flex flex-col">
          <div class="flex flex-row gap-3 items-center py-4 px-2">
            <div :class="`size-[${rskSize}px] bg_dark_6 rsk pulse`" />

            <div class="flex flex-col gap-2">
              <div class="h-[18px] w-[220px] bg_dark_6 hsk pulse" />
              <div class="h-[18px] w-[90px] bg_dark_6 hsk pulse" />
            </div>
          </div>

          <div class="flex flex-col gap-2 p-2">
            <div v-for="index in 2" :key="index" class="flex flex-row gap-2">
              <div class="h-[30px] w-5/12 bg_dark_6 hsk pulse" />
              <div class="h-[30px] w-3/12 bg_dark_6 hsk pulse" />
              <div class="h-[30px] w-4/12 bg_dark_6 hsk pulse" />
            </div>
          </div>
        </div>
      </CustomContainer>

      <CustomContainer>
        <div class="flex flex-col">
          <div v-for="index in 8" :key="index" class="flex flex-col gap-2 p-2">
            <div class="h-[20px] w-full bg_dark_6 hsk pulse" />
            <div class="h-[20px] w-3/5 bg_dark_6 hsk pulse" />
          </div>
        </div>
      </CustomContainer>
    </div>

    <div
      v-if="page === loaderPages.SALESFORCE_SYNC"
      class="flex flex-col gap-6"
    >
      <div class="h-6 w-[100px] bg_dark_6 hsk pulse" />
      <div class="h-16 w-full bg_dark_6 hsk pulse" />
      <div class="form_col">
        <div class="h-[14px] w-[100px] bg_dark_6 hsk pulse" />
        <div class="h-[34px] w-full bg_dark_6 hsk pulse" />
      </div>

      <div class="flex flex-row gap-2 items-center justify-end">
        <div class="h-[34px] w-24 bg_dark_6 hsk pulse" />
        <div class="h-[34px] w-32 bg_dark_6 hsk pulse" />
      </div>
    </div>

    <div
      v-if="page === loaderPages.UPDATE_CALL_ROUTE"
      class="flex flex-col gap-6"
    >
      <div class="form_col">
        <div class="h-[18px] w-1/6 bg_dark_6 hsk pulse" />
        <div class="h-[30px] w-full bg_dark_6 hsk pulse" />
      </div>

      <div v-for="index in 2" :key="index" class="form_col">
        <div class="h-[18px] w-1/6 bg_dark_6 hsk pulse" />
        <div class="h-[30px] w-full bg_dark_6 hsk pulse" />
        <div class="h-[14px] w-1/2 bg_dark_6 hsk pulse" />
      </div>
    </div>

    <div v-if="page === loaderPages.TRANSFER_CALL" class="flex flex-col">
      <div class="flex flex-col gap-4 px-2 py-2 border_bottom">
        <div class="h-[34px] w-full bg_dark_6 hsk pulse" />

        <div class="flex flex-col gap-[18px]">
          <div
            v-for="index in 4"
            :key="index"
            class="flex flex-row items-center gap-3"
          >
            <div
              :class="`min-w-[${rskSize}px] min-h-[${rskSize}px] bg_dark_6 rsk pulse`"
            />

            <div class="flex flex-col gap-1 w-full">
              <div class="h-[18px] w-4/5 bg_dark_6 hsk pulse" />
              <div class="h-[12px] w-2/5 bg_dark_6 hsk pulse" />
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-row justify-end gap-2 p-4">
        <div class="h-[34px] w-1/2 bg_dark_6 hsk pulse" />
        <div class="h-[34px] w-1/2 bg_dark_6 hsk pulse" />
      </div>
    </div>

    <div
      v-if="page === loaderPages.INFO_ITEM"
      class="h-5 w-1/2 bg_dark_6 hsk pulse"
    />

    <div
      v-if="page === loaderPages.DIALER"
      class="flex flex-col items-center gap-3 p-2 pointer-events-none w-full"
    >
      <div :class="`size-[${rskSize}px] bg_dark_6 rsk pulse`" />
      <div class="flex flex-col items-center w-full gap-3">
        <div class="flex flex-col gap-[6px] items-center w-full">
          <div class="h-[24px] w-1/2 bg_dark_6 hsk pulse" />
          <div class="h-[18px] w-1/3 bg_dark_6 hsk pulse" />
        </div>

        <div class="h-[14px] w-2/5 bg_dark_6 hsk pulse" />
      </div>
    </div>

    <div
      v-if="page === loaderPages.CALL_PARTICIPANTS"
      class="flex flex-col gap-1"
    >
      <div
        v-for="index in 1"
        :key="index"
        class="flex flex-row items-center justify-between"
      >
        <div class="flex flex-row items-center gap-3 w-full">
          <div :class="`w-[38px] h-[32px] bg_dark_6 rsk pulse`" />
          <div class="flex flex-col gap-[6px] w-full">
            <div class="h-[20px] w-1/2 bg_dark_6 hsk pulse" />
            <div class="h-[14px] w-1/5 bg_dark_6 hsk pulse" />
          </div>
        </div>

        <div :class="`w-[44px] h-[38px] bg_dark_6 rsk pulse`" />
      </div>
    </div>

    <div
      v-if="page === loaderPages.CALL_CAMPAIGN_CREATE"
      class="flex flex-col gap-6"
    >
      <div class="flex flex-col gap-2">
        <div class="h-[14px] w-1/6 bg_dark_6 hsk pulse" />
        <div class="flex flex-row gap-2">
          <div
            v-for="index in 2"
            :key="index"
            class="h-24 w-full bg_dark_6 hsk pulse"
          />
        </div>
      </div>

      <div v-for="index in 3" :key="index" class="flex flex-col gap-2">
        <div class="h-[14px] w-1/6 bg_dark_6 hsk pulse" />
        <div class="h-8 w-full bg_dark_6 hsk pulse" />
      </div>

      <div class="h-4 w-2/5 bg_dark_6 hsk pulse" />

      <div class="flex flex-col gap-2">
        <div class="h-[14px] w-1/6 bg_dark_6 hsk pulse" />
        <div class="flex flex-row gap-2">
          <div
            v-for="index in 2"
            :key="index"
            class="h-16 w-full bg_dark_6 hsk pulse"
          />
        </div>
      </div>

      <div class="flex flex-row gap-2 items-center justify-end">
        <div class="h-8 w-20 bg_dark_6 hsk pulse" />
        <div class="h-8 w-36 bg_dark_6 hsk pulse" />
      </div>
    </div>

    <div
      v-if="page === loaderPages.CALL_CAMPAIGN_EDIT"
      class="flex flex-col gap-6"
    >
      <div class="flex flex-col gap-2">
        <div class="h-[14px] w-1/6 bg_dark_6 hsk pulse" />
        <div class="flex flex-row gap-2">
          <div
            v-for="index in 2"
            :key="index"
            class="h-24 w-full bg_dark_6 hsk pulse"
          />
        </div>
      </div>

      <div v-for="index in 3" :key="index" class="flex flex-col gap-2">
        <div class="h-[14px] w-1/6 bg_dark_6 hsk pulse" />
        <div class="h-8 w-full bg_dark_6 hsk pulse" />
      </div>
    </div>

    <div
      v-if="page === loaderPages.VOICE_AGENT_CAMPAIGN_CREATE"
      class="flex flex-col gap-6"
    >
      <div v-for="index in 4" :key="index" class="flex flex-col gap-2">
        <div class="h-[14px] w-1/6 bg_dark_6 hsk pulse" />
        <div class="h-8 w-full bg_dark_6 hsk pulse" />
      </div>

      <div class="h-4 w-2/5 bg_dark_6 hsk pulse" />

      <div class="flex flex-col gap-2">
        <div class="h-[14px] w-1/6 bg_dark_6 hsk pulse" />
        <div class="flex flex-row gap-2">
          <div
            v-for="index in 2"
            :key="index"
            class="h-16 w-full bg_dark_6 hsk pulse"
          />
        </div>
      </div>

      <div class="flex flex-row justify-end items-center">
        <div class="h-8 w-36 bg_dark_6 hsk pulse" />
      </div>
    </div>

    <div
      v-if="page === loaderPages.VOICE_AGENT_CAMPAIGN_EDIT"
      class="flex flex-col gap-6"
    >
      <div v-for="index in 4" :key="index" class="flex flex-col gap-2">
        <div class="h-[14px] w-1/6 bg_dark_6 hsk pulse" />
        <div class="h-8 w-full bg_dark_6 hsk pulse" />
      </div>
    </div>

    <div
      v-if="page === loaderPages.EMAIL_CAMPAIGN_CREATE"
      class="flex h-[calc(100vh-150px)]"
    >
      <!-- Left Panel - Campaign Configuration -->
      <div class="w-2/5 p-6 flex flex-col gap-6 overflow-y-auto">
        <!-- Recipients Section -->
        <div class="flex flex-col gap-4">
          <div class="flex flex-row justify-between items-center">
            <div class="h-6 w-[100px] bg_dark_6 hsk pulse" />
            <div class="h-5 w-[200px] bg_dark_6 hsk pulse" />
          </div>
          <div class="flex flex-col gap-2">
            <div class="h-4 w-[80px] bg_dark_6 hsk pulse" />
            <div class="h-[40px] w-full bg_dark_6 hsk pulse" />
          </div>
          <div class="h-5 w-[240px] bg_dark_6 hsk pulse" />
        </div>

        <!-- Email Message Section -->
        <div class="flex flex-col gap-4">
          <div class="h-6 w-[120px] bg_dark_6 hsk pulse" />
          <div class="flex flex-col gap-2">
            <div class="h-4 w-[100px] bg_dark_6 hsk pulse" />
            <div class="h-[40px] w-full bg_dark_6 hsk pulse" />
          </div>
          <div class="flex flex-col gap-2">
            <div class="h-4 w-[140px] bg_dark_6 hsk pulse" />
            <div class="h-[40px] w-full bg_dark_6 hsk pulse" />
          </div>
        </div>

        <!-- Sender Details Section -->
        <div class="flex flex-col gap-4">
          <div class="h-6 w-[120px] bg_dark_6 hsk pulse" />
          <div class="flex flex-col gap-2">
            <div class="h-4 w-[100px] bg_dark_6 hsk pulse" />
            <div class="h-[40px] w-full bg_dark_6 hsk pulse" />
          </div>
          <div class="flex flex-col gap-2">
            <div class="h-4 w-[140px] bg_dark_6 hsk pulse" />
            <div class="h-[40px] w-full bg_dark_6 hsk pulse" />
          </div>
          <div class="h-5 w-[280px] bg_dark_6 hsk pulse" />
          <div class="flex flex-col gap-2">
            <div class="h-4 w-[120px] bg_dark_6 hsk pulse" />
            <div class="h-[40px] w-full bg_dark_6 hsk pulse" />
          </div>
        </div>
      </div>

      <!-- Right Panel - Content Area -->
      <div class="w-3/5 p-6 flex flex-col">
        <div class="h-6 w-[200px] bg_dark_6 hsk pulse mb-4" />

        <!-- Content Type Cards -->
        <div class="flex flex-col gap-4 flex-grow">
          <!-- Large Card -->
          <div class="h-1/2 w-full bg_dark_6 hsk pulse rounded-lg" />

          <!-- Two Small Cards -->
          <div class="flex flex-row gap-4 h-1/2 w-full">
            <div class="h-full w-1/2 bg_dark_6 hsk pulse rounded-lg" />
            <div class="h-full w-1/2 bg_dark_6 hsk pulse rounded-lg" />
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="page === loaderPages.CAMPAIGN_VIEW_DETAILS"
      class="flex flex-col gap-2"
    >
      <div
        v-for="index in 6"
        :key="index"
        class="flex flex-row items-center gap-3 w-full p-2"
      >
        <div :class="`w-[46px] h-[42px] bg_dark_6 rsk pulse`" />
        <div class="flex flex-col gap-[6px] w-full">
          <div class="h-[20px] w-1/2 bg_dark_6 hsk pulse" />
          <div class="h-[14px] w-1/5 bg_dark_6 hsk pulse" />
        </div>
      </div>
    </div>

    <div
      v-if="page === loaderPages.NUMBER_SUBMISSION_STATUS"
      class="flex flex-col gap-4 p-3 rounded-lg border_8"
    >
      <div class="flex flex-col gap-1">
        <div class="h-[14px] w-full bg_dark_6 hsk pulse" />
        <div class="h-[14px] w-2/5 bg_dark_6 hsk pulse" />
      </div>

      <div class="h-8 w-24 bg_dark_6 hsk pulse" />
    </div>

    <div
      v-if="page === loaderPages.MANAGE_BUSINESS_SUBMISSION"
      class="grid grid-cols-12 gap-6 w-full"
    >
      <div class="col-span-4 flex flex-col gap-2">
        <div
          v-for="index in 3"
          :key="index"
          class="h-10 w-full bg_dark_6 hsk pulse"
        />
      </div>

      <div class="col-span-8 flex flex-col gap-6">
        <div v-for="index in 4" :key="index" class="flex flex-col gap-1">
          <div class="h-[18px] w-1/2 bg_dark_6 hsk pulse" />
          <div class="h-9 w-full bg_dark_6 hsk pulse" />
        </div>
      </div>
    </div>

    <div
      v-if="page === loaderPages.EMAIL_ACTIVITY"
      :class="['grid', 'grid-cols-12', 'gap-4', 'w-full', 'h-[350px]']"
    >
      <div
        v-for="emailIndex in 2"
        :key="emailIndex"
        class="col-span-12 flex flex-col gap-5 bg_dark_4 w-full"
      >
        <div class="flex flex-row justify-between">
          <div class="h-[15px] w-1/4 bg_dark_6 hsk pulse" />
          <div class="h-[15px] w-1/4 bg_dark_6 hsk pulse" />
        </div>

        <div class="flex flex-col gap-2">
          <div
            v-for="fieldIndex in 3"
            :key="fieldIndex"
            class="flex flex-row gap-2"
          >
            <div class="h-[15px] w-[44px] bg_dark_6 hsk pulse" />
            <div class="h-[15px] w-1/2 bg_dark_6 hsk pulse" />
          </div>
        </div>

        <div v-if="emailIndex === 1" class="flex flex-col gap-4">
          <div
            v-for="contentIndex in 3"
            :key="contentIndex"
            class="h-[15px] w-full bg_dark_6 hsk pulse"
          />
        </div>
        <div v-else class="h-[15px] w-full bg_dark_6 hsk pulse" />

        <div
          v-if="emailIndex === 1"
          class="h-[15px] w-1/3 bg_dark_6 hsk pulse"
        />
        <div
          v-if="emailIndex === 1"
          class="h-[15px] w-1/4 bg_dark_6 hsk pulse"
        />

        <div class="flex flex-row gap-1 items-center">
          <div
            v-for="iconIndex in 4"
            :key="iconIndex"
            class="h-8 w-8 bg_dark_6 pulse rounded-full"
          />
        </div>
      </div>
    </div>

    <div
      v-if="page === loaderPages.MEETING_RECORDING"
      class="flex flex-col gap-2"
    >
      <div class="aspect-[9/4] bg_dark_6 hsk pulse" />
      <div class="bg_dark_6 hsk pulse" style="height: calc(100vh - 700px)" />
    </div>

    <div
      v-if="page === loaderPages.MEETING_SUMMARY"
      class="flex flex-col gap-2"
    >
      <div
        v-for="index in 6"
        :key="index"
        class="h-[60px] w-full bg_dark_6 hsk pulse"
      />
    </div>

    <div
      v-if="page === loaderPages.MEETING_INTELLIGENCE"
      class="flex flex-col gap-6"
    >
      <div class="flex flex-col gap-6">
        <div class="h-7 w-1/3 bg_dark_6 hsk pulse" />

        <div class="flex flex-col gap-1">
          <div class="h-5 w-1/6 bg_dark_6 hsk pulse" />
          <div class="h-[26px] w-full bg_dark_6 hsk pulse" />
        </div>

        <div class="flex flex-col gap-2">
          <div
            v-for="index in 2"
            :key="index"
            class="h-[90px] w-full bg_dark_6 hsk pulse"
          />
        </div>
      </div>

      <div class="flex flex-col gap-6">
        <div class="h-7 w-1/4 bg_dark_6 hsk pulse" />

        <div class="flex flex-col gap-1">
          <div class="h-4 w-1/3 full bg_dark_6 hsk pulse" />
          <div class="h-9 w-1/2 bg_dark_6 hsk pulse" />
        </div>
      </div>
    </div>

    <div v-if="page === loaderPages.AUDIT_TRAIL" class="flex flex-col gap-2">
      <div
        v-for="index in 8"
        :key="index"
        class="h-[50px] w-full full !rounded-[10px] bg_dark_6 hsk pulse"
      />
    </div>

    <div
      v-if="page === loaderPages.VALIDATION_MODAL"
      class="flex flex-col gap-6"
    >
      <div class="flex flex-col gap-2">
        <div class="h-8 w-2/3 bg_dark_6 hsk pulse" />
        <div class="h-[50px] w-full bg_dark_6 hsk pulse" />
      </div>
    </div>

    <div
      v-if="page === loaderPages.SENDER_DETAILS_MODAL"
      class="flex flex-col gap-6"
    >
      <div class="flex flex-col gap-3">
        <div class="h-4 w-1/3 bg_dark_6 hsk pulse" />
        <div class="flex flex-col gap-2">
          <div class="h-4 w-1/4 bg_dark_6 hsk pulse" />
          <div class="h-[40px] w-full bg_dark_6 hsk pulse" />
        </div>
        <div class="h-6 w-3/4 bg_dark_6 hsk pulse" />
      </div>
    </div>
    <div v-if="page === loaderPages.WATERFALL" class="flex flex-col gap-6">
      <div class="flex flex-col gap-[40px]">
        <div
          v-for="sectionIndex in 2"
          :key="sectionIndex"
          class="flex flex-col gap-6"
        >
          <div class="flex flex-col gap-2">
            <div class="h-4 w-1/5 bg_dark_6 hsk pulse" />
            <div class="h-4 w-1/3 bg_dark_6 hsk pulse" />
          </div>
          <div class="flex flex-col gap-3">
            <div
              v-for="rowIndex in 3"
              :key="rowIndex"
              class="h-[50px] w-full bg_dark_6 hsk pulse"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="page === loaderPages.KNOWLEDGE_BASE"
      class="bg_dark_6 hsk pulse"
      style="height: calc(100vh - (230px + var(--banner-height)))"
    />

    <div
      v-if="page === loaderPages.LIVE_CHAT_WIDGET"
      class="grid grid-cols-1 lg:grid-cols-2 gap-8 px-[6vw] md:px-[12vw] overflow-y-scroll"
    >
      <div
        class="col-span-1 flex flex-col gap-10"
        style="height: calc(100vh - (162px + var(--banner-height)))"
      >
        <div class="h-16 bg_dark_6 hsk pulse" />
        <div class="h-64 bg_dark_6 hsk pulse" />
        <div class="h-28 bg_dark_6 hsk pulse" />
        <div class="h-28 bg_dark_6 hsk pulse" />
        <div class="h-40 bg_dark_6 hsk pulse" />
      </div>

      <div
        class="col-span-1 bg_dark_6 hsk pulse"
        style="height: calc(100vh - (162px + var(--banner-height)))"
      />
    </div>

    <div
      v-if="page === loaderPages.INBOX_LEFT_PANEL"
      class="flex flex-col gap-1 p-2"
    >
      <div
        v-for="index in 6"
        :key="index"
        class="h-[66px] bg_dark_6 hsk pulse"
      />
    </div>

    <div
      v-if="page === loaderPages.INBOX_CENTER_PANEL"
      class="flex flex-col gap-4 p-4"
    >
      <div
        class="h-full bg_dark_6 hsk pulse"
        style="height: calc(100vh - (240px + var(--banner-height)))"
      />
      <div class="h-36 bg_dark_6 hsk pulse" />
    </div>

    <div
      v-if="page === loaderPages.INBOX_CENTRAL_PANEL_TOP_BAR"
      class="h-[28px] bg_dark_6 hsk pulse"
    />

    <div
      v-if="page === loaderPages.CHAT_BROWSER_PANEL"
      class="flex flex-col gap-1 p-2"
    >
      <div
        v-for="index in 6"
        :key="index"
        class="h-[66px] bg_dark_6 hsk pulse"
      />
    </div>

    <div
      v-if="page === loaderPages.CHAT_LIST_ITEM"
      class="flex flex-row gap-2 items-center"
    >
      <div class="size-[38px] rounded-full bg_dark_6 rsk pulse" />
      <div class="flex flex-col gap-2 w-full">
        <div class="h-4 bg_dark_6 hsk pulse w-3/4" />
        <div class="h-3 bg_dark_6 hsk pulse w-1/2" />
      </div>
    </div>

    <div
      v-if="page === loaderPages.CHAT_MESSAGES"
      class="flex flex-col gap-4 p-4"
    >
      <div v-for="index in 7" :key="index" class="flex flex-row gap-2">
        <div class="w-7 h-7 rounded-full bg_dark_6 hsk pulse flex-shrink-0" />
        <div class="flex flex-col gap-2 flex-1">
          <div class="h-4 w-24 bg_dark_6 hsk pulse" />
          <div class="h-16 w-full bg_dark_6 hsk pulse" />
        </div>
      </div>
    </div>

    <div v-if="page === loaderPages.NUMBER_CHECK">
      <div class="h-14 w-full bg_dark_6 hsk pulse rounded-md" />
    </div>

    <div v-if="page === loaderPages.FORM_INPUT" class="flex flex-col gap-5">
      <div class="flex flex-col" style="gap: 20px">
        <div v-for="index in 10" :key="index" class="flex flex-col gap-2">
          <div class="h-4 w-[120px] bg_dark_6 hsk pulse" />
          <div class="h-8 w-full bg_dark_6 hsk pulse" />
        </div>
      </div>
    </div>

    <div
      v-if="page === loaderPages.AGI_ASSISTANT_CHAT"
      class="absolute top-full right-0 max-w-[350px] max-h-[600px] min-w-[350px] min-h-[450px] mt-2 bg-[var(--background-color)] border border-[var(--white-opacity-8)] rounded-xl shadow-lg flex flex-col z-[1000] proxima_nova"
    >
      <!-- Header Section -->
      <div
        class="flex justify-between items-center p-4 border-b border-[var(--white-opacity-8)]"
      >
        <div class="flex items-center gap-1">
          <div class="w-4 h-4 bg_dark_6 hsk pulse" />
          <div class="h-[14px] w-[80px] bg_dark_6 hsk pulse" />
        </div>
        <div class="size-5 bg_dark_6 hsk pulse" />
      </div>

      <!-- Chat Messages Area -->
      <div class="flex-1 overflow-y-auto p-4 flex flex-col gap-3">
        <!-- Assistant Message -->
        <div class="flex gap-2 max-w-full">
          <div class="flex-shrink-0 flex items-start mt-0.5">
            <div class="size-6 bg_dark_6 rsk pulse" />
          </div>
          <div class="flex flex-col gap-1 max-w-[75%] items-start">
            <div
              class="px-3 py-2 rounded-xl text-sm bg_dark_6 hsk pulse"
              style="width: 200px; height: 40px"
            />
            <div class="h-[11px] w-[60px] bg_dark_6 hsk pulse" />
          </div>
        </div>

        <!-- User Message -->
        <div class="flex gap-2 max-w-full flex-row-reverse">
          <div class="flex-shrink-0 flex items-start mt-0.5">
            <div class="size-6 bg_dark_6 rsk pulse" />
          </div>
          <div class="flex flex-col gap-1 max-w-[75%] items-end">
            <div
              class="px-3 py-2 rounded-xl text-sm bg_dark_6 hsk pulse"
              style="width: 150px; height: 35px"
            />
            <div class="h-[11px] w-[50px] bg_dark_6 hsk pulse" />
          </div>
        </div>

        <!-- Another Assistant Message -->
        <div class="flex gap-2 max-w-full">
          <div class="flex-shrink-0 flex items-start mt-0.5">
            <div class="size-6 bg_dark_6 rsk pulse" />
          </div>
          <div class="flex flex-col gap-1 max-w-[75%] items-start">
            <div
              class="px-3 py-2 rounded-xl text-sm bg_dark_6 hsk pulse"
              style="width: 250px; height: 45px"
            />
            <div class="h-[11px] w-[70px] bg_dark_6 hsk pulse" />
          </div>
        </div>

        <!-- Another User Message -->
        <div class="flex gap-2 max-w-full flex-row-reverse">
          <div class="flex-shrink-0 flex items-start mt-0.5">
            <div class="size-6 bg_dark_6 rsk pulse" />
          </div>
          <div class="flex flex-col gap-1 max-w-[75%] items-end">
            <div
              class="px-3 py-2 rounded-xl text-sm bg_dark_6 hsk pulse"
              style="width: 180px; height: 30px"
            />
            <div class="h-[11px] w-[55px] bg_dark_6 hsk pulse" />
          </div>
        </div>
      </div>

      <!-- Input Area -->
      <div class="relative mx-2 mb-1">
        <div
          class="w-full bg-[var(--white-opacity-4)] rounded-xl px-4 py-3 pr-12"
          style="height: 80px"
        >
          <div class="h-[14px] w-full bg_dark_6 hsk pulse" />
          <div class="h-[14px] w-3/4 bg_dark_6 hsk pulse mt-2" />
        </div>
        <div class="absolute right-3 bottom-3 size-5 bg_dark_6 hsk pulse" />
      </div>
    </div>

    <div
      v-if="page === loaderPages.AGI_ASSISTANT_CHAT_MESSAGES"
      class="flex flex-col gap-3"
    >
      <!-- Assistant Message -->
      <div class="flex gap-2 max-w-full">
        <div class="flex-shrink-0 flex items-start mt-0.5">
          <div class="size-6 bg_dark_6 rsk pulse" />
        </div>
        <div class="flex flex-col gap-1 max-w-[75%] items-start">
          <div
            class="px-3 py-2 rounded-xl text-sm bg_dark_6 hsk pulse"
            style="width: 200px; height: 40px"
          />
          <div class="h-[11px] w-[60px] bg_dark_6 hsk pulse" />
        </div>
      </div>

      <!-- User Message -->
      <div class="flex gap-2 max-w-full flex-row-reverse">
        <div class="flex-shrink-0 flex items-start mt-0.5">
          <div class="size-6 bg_dark_6 rsk pulse" />
        </div>
        <div class="flex flex-col gap-1 max-w-[75%] items-end">
          <div
            class="px-3 py-2 rounded-xl text-sm bg_dark_6 hsk pulse"
            style="width: 150px; height: 35px"
          />
          <div class="h-[11px] w-[50px] bg_dark_6 hsk pulse" />
        </div>
      </div>

      <!-- Another Assistant Message -->
      <div class="flex gap-2 max-w-full">
        <div class="flex-shrink-0 flex items-start mt-0.5">
          <div class="size-6 bg_dark_6 rsk pulse" />
        </div>
        <div class="flex flex-col gap-1 max-w-[75%] items-start">
          <div
            class="px-3 py-2 rounded-xl text-sm bg_dark_6 hsk pulse"
            style="width: 250px; height: 45px"
          />
          <div class="h-[11px] w-[70px] bg_dark_6 hsk pulse" />
        </div>
      </div>

      <!-- Another User Message -->
      <div class="flex gap-2 max-w-full flex-row-reverse">
        <div class="flex-shrink-0 flex items-start mt-0.5">
          <div class="size-6 bg_dark_6 rsk pulse" />
        </div>
        <div class="flex flex-col gap-1 max-w-[75%] items-end">
          <div
            class="px-3 py-2 rounded-xl text-sm bg_dark_6 hsk pulse"
            style="width: 180px; height: 30px"
          />
          <div class="h-[11px] w-[55px] bg_dark_6 hsk pulse" />
        </div>
      </div>
    </div>

    <div v-if="page === loaderPages.MANAGE_COLUMNS" class="flex flex-col gap-2">
      <div
        v-for="index in 5"
        :key="index"
        class="h-[30px] w-full bg_dark_6 hsk pulse"
      />
    </div>

    <div v-if="page === loaderPages.ACTIVITY_TAB" class="flex flex-col gap-2">
      <div
        v-for="index in 6"
        :key="index"
        class="bg_dark_4 w-full flex flex-col gap-2"
      >
        <div class="flex flex-row gap-2 items-start">
          <div :class="`size-[${rskSize}px] bg_dark_6 rsk pulse`" />
          <div class="flex flex-col gap-2 w-full">
            <div class="flex flex-row justify-between">
              <div class="h-[18px] w-3/5 bg_dark_6 hsk pulse" />
              <div class="h-[18px] w-12 bg_dark_6 hsk pulse" />
            </div>
            <div class="h-[14px] w-2/5 bg_dark_6 hsk pulse" />
            <div class="h-[15px] w-full bg_dark_6 hsk pulse mt-2" />
            <div class="h-[15px] w-4/5 bg_dark_6 hsk pulse" />
            <div class="h-[15px] w-3/5 bg_dark_6 hsk pulse" />
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="page === loaderPages.PHONE_NUMBER_DETAILS"
      class="flex flex-col gap-10"
    >
      <div class="flex flex-col gap-1">
        <div class="h-[14px] w-1/5 bg_dark_6 hsk pulse" />
        <div class="h-[84px] w-full bg_dark_6 hsk pulse" />
      </div>

      <div class="flex flex-col gap-6">
        <div v-for="index in 4" :key="index" class="flex flex-col gap-1">
          <div class="h-[14px] w-1/4 bg_dark_6 hsk pulse" />
          <div class="h-[36px] w-full bg_dark_6 hsk pulse" />
        </div>
      </div>
    </div>

    <div
      v-if="page === loaderPages.OUTBOUND_SELECT"
      class="flex flex-col gap-1"
    >
      <div class="h-[14px] w-1/4 bg_dark_6 hsk pulse" />
      <div class="h-[36px] w-full bg_dark_6 hsk pulse" />
    </div>

    <div v-if="page === loaderPages.ADD_TASK_MODAL" class="flex flex-col gap-4">
      <div class="h-6 w-1/4 bg_dark_6 hsk pulse" />

      <div class="h-[42px] w-full bg_dark_6 hsk pulse" />

      <div class="h-[120px] w-full bg_dark_6 hsk pulse" />

      <div class="flex flex-wrap gap-2">
        <div
          v-for="index in 4"
          :key="index"
          class="h-[26px] w-[120px] bg_dark_6 hsk pulse"
        />
      </div>
    </div>

    <div v-if="page === loaderPages.SPACES_PANEL" class="flex flex-col gap-1">
      <div
        v-for="spaceIndex in 10"
        :key="spaceIndex"
        class="flex flex-col gap-[2px] bg_dark_6 hsk pulse h-[40px] w-full"
      />
    </div>

    <div v-if="page === loaderPages.TREE" class="flex flex-col gap-2">
      <div v-for="index in 5" :key="index">
        <div class="flex flex-col gap-1">
          <div class="h-[20px] w-1/5 bg_dark_6 hsk pulse" />
          <div class="h-[20px] w-1/2 bg_dark_6 hsk pulse ml-4" />
          <div class="h-[20px] w-1/2 bg_dark_6 hsk pulse ml-4" />
        </div>
      </div>
    </div>

    <div v-if="page === loaderPages.SUB_OBJECT_MODAL" class="flex gap-1">
      <div
        v-for="index in 2"
        :key="index"
        class="h-[40px] w-1/2 bg_dark_6 hsk pulse"
      />
    </div>

    <div v-if="page === loaderPages.COMPONENT_CARD" class="flex flex-col gap-2">
      <div class="h-[200px] w-full bg_dark_6 hsk pulse" />
    </div>

    <div
      v-if="page === loaderPages.ANALYTICS_EDITOR"
      class="flex flex-col no_padding_container"
    >
      <div class="flex flex-row items-center justify-between p-4 border_bottom">
        <div class="w-32 h-10 bg_dark_6 hsk pulse" />
        <div class="w-24 h-10 bg_dark_6 hsk pulse" />
      </div>

      <div class="grid grid-cols-12">
        <div class="col-span-5 p-4 border_right">
          <div
            class="w-full bg_dark_6 hsk pulse"
            style="height: calc(100vh - (120px + var(--banner-height)))"
          />
        </div>

        <div class="col-span-7 p-4">
          <div
            class="w-full bg_dark_6 hsk pulse"
            style="height: calc(100vh - (120px + var(--banner-height)))"
          />
        </div>
      </div>
    </div>

    <div v-if="page === loaderPages.OBJECT_FILTER_SELECTOR" class="p-4">
      <div
        class="w-full h-full bg_dark_6 hsk pulse"
        style="height: calc(100vh - (120px + var(--banner-height)))"
      />
    </div>

    <div
      v-if="page === loaderPages.VOICE_AGENT_BEHAVIOUR"
      class="flex flex-col gap-6"
    >
      <div class="flex flex-col gap-2">
        <div class="h-[20px] w-[200px] bg_dark_6 hsk pulse" />
        <div class="h-[16px] w-[400px] bg_dark_6 hsk pulse" />
      </div>

      <div class="flex flex-col gap-2">
        <div class="h-[16px] w-[100px] bg_dark_6 hsk pulse" />
        <div class="h-[50px] w-full bg_dark_6 hsk pulse" />
      </div>

      <div class="flex flex-col gap-2">
        <div class="h-[16px] w-[120px] bg_dark_6 hsk pulse" />
        <div class="h-[50px] w-full bg_dark_6 hsk pulse" />
      </div>

      <div class="flex flex-col gap-2">
        <div class="h-[16px] w-[180px] bg_dark_6 hsk pulse" />
        <div class="h-[100px] w-full bg_dark_6 hsk pulse" />
      </div>

      <div class="flex flex-col gap-2">
        <div class="h-[16px] w-[220px] bg_dark_6 hsk pulse" />
        <div class="h-[200px] w-full bg_dark_6 hsk pulse" />
      </div>
    </div>

    <div
      v-if="page === loaderPages.SELECT"
      class="h-8 w-full bg_dark_6 hsk pulse"
    />

    <div
      v-if="page === loaderPages.PERMISSION_MANAGEMENT"
      class="flex gap-6 w-full"
    >
      <div class="w-64 flex flex-col gap-2">
        <div class="h-[60px] bg_dark_6 hsk pulse" />
        <div
          v-for="index in 5"
          :key="index"
          class="h-[40px] w-full bg_dark_6 hsk pulse"
        />
      </div>

      <div class="flex-1 flex flex-col gap-4">
        <div class="h-[50px] w-full flex justify-end">
          <div class="h-[40px] w-[120px] bg_dark_6 hsk pulse" />
        </div>
        <div class="flex flex-col gap-2">
          <div
            v-for="index in 6"
            :key="index"
            class="flex flex-col gap-2 p-4 border_8 rounded-lg"
          >
            <div class="flex flex-row items-center justify-between">
              <div class="flex flex-col gap-1 flex-1">
                <div class="h-[18px] w-1/3 bg_dark_6 hsk pulse" />
                <div class="h-[14px] w-2/3 bg_dark_6 hsk pulse" />
              </div>
              <div class="h-[24px] w-[44px] bg_dark_6 hsk pulse rounded-full" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="page === loaderPages.PERMISSION_SECTIONS"
      class="flex flex-col gap-2"
    >
      <div
        v-for="index in 8"
        :key="index"
        class="flex flex-col gap-2 p-4 border_8 rounded-lg"
      >
        <div class="flex flex-row items-center justify-between">
          <div class="flex flex-col gap-1 flex-1">
            <div class="h-[18px] w-1/3 bg_dark_6 hsk pulse" />
            <div class="h-[14px] w-2/3 bg_dark_6 hsk pulse" />
          </div>
          <div class="h-[22px] w-[44px] bg_dark_6 hsk pulse rounded-full" />
        </div>
      </div>
    </div>

    <div
      v-if="page === loaderPages.ANALYTICS_TEMPLATES"
      class="flex flex-col gap-10"
    >
      <div v-for="cIndex in 2" :key="cIndex" class="flex flex-col gap-4">
        <div class="w-1/5 h-[28px] bg_dark_6 hsk pulse" />

        <div class="grid grid-cols-2 gap-4">
          <div v-for="tIndex in 4" :key="tIndex" class="col-span-1 flex">
            <div class="w-full h-[100px] !rounded-lg bg_dark_6 hsk pulse" />
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="page === loaderPages.ANALYTICS_TEMPLATES_VIEW"
      class="grid grid-cols-4 p-4 gap-6"
    >
      <div class="col-span-1 flex flex-col gap-8">
        <div class="w-full h-[30px] bg_dark_6 hsk pulse" />

        <div class="flex flex-col gap-1">
          <div class="w-2/5 h-[16px] bg_dark_6 hsk pulse" />
          <div class="w-full h-[30px] bg_dark_6 hsk pulse" />
        </div>
      </div>

      <div class="col-span-3 flex flex-col gap-10">
        <div v-for="cIndex in 2" :key="cIndex" class="flex flex-col gap-4">
          <div class="w-1/5 h-[28px] bg_dark_6 hsk pulse" />

          <div class="grid grid-cols-2 gap-4">
            <div v-for="tIndex in 4" :key="tIndex" class="col-span-1 flex">
              <div class="w-full h-[100px] !rounded-lg bg_dark_6 hsk pulse" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="page === loaderPages.LIVE_ASSIST_WIDGET"
      class="flex flex-col gap-2"
    >
      <div
        v-for="idx in 3"
        :key="idx"
        class="flex flex-col p-3 gap-2.5 rounded-lg"
        style="
          background: var(--live-assist-widget-inner-bg);
          border: 0.8px solid var(--white-opacity-8);
          border-radius: 7.92px;
        "
      >
        <div
          class="h-2.5 rounded bg_dark_6 hsk pulse"
          :style="{ width: idx === 1 ? '60%' : idx === 2 ? '50%' : '55%' }"
        />
        <div class="flex flex-col gap-1.5">
          <div
            class="h-2 rounded bg_dark_6 hsk pulse"
            :style="{ width: idx === 1 ? '100%' : idx === 2 ? '90%' : '95%' }"
          />
          <div
            class="h-2 rounded bg_dark_6 hsk pulse"
            :style="{ width: idx === 1 ? '85%' : idx === 2 ? '75%' : '65%' }"
          />
          <div
            v-if="idx === 1"
            class="h-2 rounded bg_dark_6 hsk pulse"
            style="width: 70%"
          />
        </div>
      </div>
    </div>

    <div v-if="page === loaderPages.REPO_CODE" class="flex flex-col gap-4">
      <div class="w-20 h-6 rounded-2xl bg_dark_6 hsk pulse" />

      <div class="flex flex-col rounded-lg border_8">
        <div
          v-for="index in 10"
          :key="index"
          class="p-4"
          :class="{ border_bottom: index !== 10 }"
        >
          <div class="w-full h-8 rounded-lg bg_dark_6 hsk pulse" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { imageNames } from "@/src/constants/imageConstants.js";
import { loaderPages } from "@/src/constants/loaderConstants.js";
import ThemeImage from "@/src/components/ThemeImage.vue";
import CustomContainer from "@/src/components/CustomContainer.vue";
import InfoGrid from "@/src/components/info_components/InfoGrid.vue";

const props = defineProps({
  page: { type: String, required: true },
  index: { type: [String, Number], required: false },
  rskSize: { type: Number, required: false, default: 34 },
  text: { type: String, required: false },
  containerHeight: { type: [Number, String], default: "" },
});
</script>

<style scoped>
.container_bg_color {
  background: var(--white-opacity-4);
}

.bg_dark_6 {
  background: linear-gradient(
    90deg,
    var(--white-opacity-6) 25%,
    var(--white-opacity-8) 50%,
    var(--white-opacity-6) 75%
  );
  background-size: 200% 100%;
  animation: shimmer 2s ease-in-out infinite;
}

.hsk {
  border-radius: 4px;
}

.rsk {
  border-radius: 9999px;
}

.bg_dark_4 {
  border-radius: 8px;
  padding: 12px;
  border: 1px solid var(--white-opacity-8);
  background: var(--white-opacity-4);
}

.pulse {
  animation: pulse 1.5s ease-in-out infinite;
  will-change: opacity;
  transform: translateZ(0);
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
}

/* Optimize skeleton rendering */
.hsk,
.rsk {
  will-change: opacity;
  transform: translateZ(0);
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>
